const f_O5zAEbylVEdnF53mAmkBE3s7hKZpLJNccIpVfycsVjU = ({
    name: 'Test',
    label: 'test',
});

const b_ZD8xe0tDDHb6WP9zG09nDC_r4pdum22GLDmvdfRSc8Y = ({
    bundle: 'quote',
    editor: {
        previewWidth: 600,
        editTitle: (el) => el.querySelector('figcaption')?.textContent,
        addBehaviour: 'no-form',
    },
    options: {
        alignment: {
            type: 'radios',
            label: 'Alignment',
            default: 'left',
            displayAs: 'icons',
            options: {
                left: { label: 'left', icon: 'icon-blokkli-option-left' },
                right: { label: 'right', icon: 'icon-blokkli-option-right' },
            },
        },
    },
});

const b_z_PD1d7ayF6D7T7L6jozzRtRjSnUKNgO68hY8spvjkY = ({
    bundle: "from_library"
});

const b_YTo_Bh_BHKb8cDCaTnlwUrxSl_UN1TSqX71yK4_5ENk = ({
    bundle: "blokkli_fragment",
    editor: {
        disableEdit: true
    }
});

const b_xnlIk4Vz0LPjxyXHLu4BcqJSupR_kxyxi8YBrepvpLY = ({
    bundle: 'iframe',
    globalOptions: ['spacing'],
});

const b_W69iu88z8RJtGf7iQwLzzEk_jf_97USLPm9ncbU_wFM = ({
    bundle: 'teaser_list',
    options: {
        teaserStyle: {
            type: 'radios',
            label: 'Darstellung',
            default: 'grid',
            displayAs: 'icons',
            options: {
                grid: { label: 'Grid', icon: 'icon-blokkli-option-grid' },
                slider: {
                    label: 'Slider',
                    icon: 'icon-blokkli-option-slider-desktop',
                },
            },
        },
    },
    globalOptions: ['spacing'],
    editor: {
        editTitle: (el) => el.querySelector('h2')?.innerText,
        addBehaviour: 'no-form',
    },
    propsFieldMapping: {
        header: 'field_header',
        paragraphs: 'field_paragraphs_teaser',
    },
});

const b_w2jcqcaAlQb_v0OXP3TSWg8_fVRDbSzlDlOcUvL_YIo = ({
    bundle: 'iframe_jobs',
    globalOptions: ['spacing'],
});

const b_SXVQBz7vbenfDltbhVZKmBaMSNLmgswdA4XXLI5E7UI = ({
    bundle: 'contact',
    editor: {
        addBehaviour: 'no-form',
        editTitle: (el) => el.textContent,
        getDraggableElement: (el) => el.querySelector('.ck-content'),
        determineVisibleOptions: (ctx) => {
            if (!ctx.parentType) {
                return ['spacing'];
            }
            return [];
        },
    },
    globalOptions: ['spacing'],
});

const b_SirCWvX_KaO4m0tSI015B821qfAXhlJaUkOwWX2dqA4 = ({
    bundle: 'newsletter',
});

const b_rZrzUDep3sWJ0Fl9scOVmIOi18oquO7ieJxefD1cflU = ({
    bundle: 'link_list',
    editor: {
        editTitle: (el) => el.querySelector('a')?.innerText,
    },
    globalOptions: ['spacing'],
    options: {
        color: {
            type: 'radios',
            label: 'Hintergrundfarbe',
            default: 'gray',
            displayAs: 'colors',
            options: {
                gray: { class: 'bg-gray-300', label: 'Grau' },
                green: { class: 'bg-lightGreen', label: 'Grün' },
            },
        },
    },
    propsFieldMapping: {
        header: 'field_header',
        paragraphs: 'field_content',
    },
});

const b_Rnax2e3Lz5SEMemyKl3YlSKNZVEBzCoCHhxEh_X5764 = ({
    bundle: 'accordeon',
    editor: {
        editTitle: (el) => el.querySelector('h2')?.textContent,
        addBehaviour: 'no-form',
        determineVisibleOptions: (ctx) => {
            const options = [];
            if (!ctx.parentType) {
                options.push('showInToc');
            }
            return options;
        },
    },
    globalOptions: ['showInToc'],
    propsFieldMapping: {
        paragraphs: 'field_content',
    },
});

const b_O6UlFcc3wchuJgPEPOu_dh_UHgzVN94ftwTjQnP1LTM = ({
    bundle: 'webform',
    chunkName: 'rare',
});

const b_NqYDVS6361AcEiJv9sojhqcvqaXzaOHZg82tP3Rg88Q = ({
    bundle: 'video',
    editor: {
        editTitle: (el) => el.querySelector('h2')?.innerText,
    },
    globalOptions: ['spacing'],
    options: {
        format: {
            type: 'radios',
            label: 'Bildformat',
            default: 'text',
            displayAs: 'icons',
            options: {
                big: { label: 'large', icon: 'icon-blokkli-option-large' },
                text: { label: 'small', icon: 'icon-blokkli-option-small' },
            },
        },
    },
});

const b_fxcUnyIjUiIWx1rgtX0dLiNM22aEC33fVRHHLdqiWXE = ({
    bundle: 'text_image',
});

const b_EVC1oo9qUqE74QMcI_ukbajtArb6zExmMcpVexWg0nc = ({
    bundle: 'gallery',
});

const b_eh8tCsK7wnmnQy5zHUBJxx_anqZvWJqfOx4Y5p_WPyM = ({
    bundle: 'text',
    editor: {
        addBehaviour: 'no-form',
        editTitle: (el) => el.textContent,
        getDraggableElement: (el) => el.querySelector('.ck-content'),
        determineVisibleOptions: (ctx) => {
            const options = [];
            if (!ctx.parentType) {
                options.push('spacing');
            }
            return options;
        },
    },
    globalOptions: ['spacing'],
});

const b_d5SfFyIgCVs5a6nzYu6vWLBHfuYC7j0_XKqItaVSsIU = ({
    bundle: 'link',
    editor: {
        editTitle: (el) => el.querySelector('a')?.innerText,
    },
});

const b_ch06ugUeskqgpetl2fP0tti_H8DvzqAXNBWGRc5aj_U = ({
    bundle: 'icon_text_list',
    editor: {
        editTitle: (el) => el.querySelector('h2')?.textContent,
        getDraggableElement: (el) => el.querySelector('.paragraph-icon-text-list'),
    },
    globalOptions: ['spacing'],
    propsFieldMapping: {
        paragraphs: 'field_content',
    },
});

const b_cDj4TWfjFUrwMFcI_1KHarrXDMTqdsYf0rg5O_AUVVw = ({
    bundle: 'teaser',
    options: {
        infoBoxAlignment: {
            type: 'radios',
            label: 'Info box alignment',
            default: 'bottom',
            displayAs: 'icons',
            options: {
                top: {
                    label: 'Ausrichtung oben',
                    icon: 'icon-blokkli-option-box-top',
                },
                bottom: {
                    label: 'Ausrichtung unten',
                    icon: 'icon-blokkli-option-box-bottom',
                },
            },
        },
    },
    editor: {
        editTitle: (el) => el.querySelector('h3')?.innerText,
        mockProps: (text) => {
            return {
                overrideTitle: text || 'Teaser Titel',
                link: {
                    uri: {
                        path: '/',
                    },
                },
            };
        },
        determineVisibleOptions: (ctx) => {
            const options = [];
            if (!ctx.parentType) {
                options.push('infoBoxAlignment');
            }
            return options;
        },
    },
});

const b_BwK9rV92vfuPZdhNtUxjMOlPQ1sq0Wlx5d5DPsXUalY = ({
    bundle: 'button',
    editor: {
        editTitle: (el) => el.textContent,
    },
    options: {
        buttonType: {
            type: 'radios',
            label: 'Button Type',
            default: 'standard',
            options: {
                standard: 'Default',
                filled: 'Filled',
                textOnly: 'Text only',
                floating: 'Floating',
            },
        },
    },
});

const b_bUm918TQ8HQXeKMB15CFG0WaTR2QLL9FNdg3AzSu2ss = ({
    bundle: 'title',
    editor: {
        addBehaviour: 'no-form',
        editTitle: (el) => el.textContent,
        getDraggableElement: (el) => el.querySelector('.ck-content'),
        determineVisibleOptions: (ctx) => {
            const options = [];
            if (!ctx.parentType) {
                options.push('spacing');
            }
            if (ctx.parentType !== 'accordeon') {
                options.push('showInToc');
            }
            return options;
        },
    },
    globalOptions: ['spacing', 'showInToc'],
});

const b_AYZjamP3sEPcyFtMO9NMBzVvwxoCSduwY8K9sDLZx90 = ({
    bundle: 'info_box',
    editor: {
        addBehaviour: 'no-form',
        editTitle: (el) => el.textContent,
        getDraggableElement: (el) => el.querySelector('.ck-content'),
        determineVisibleOptions: (ctx) => {
            if (!ctx.parentType) {
                return ['spacing', 'showInToc'];
            }
            return [];
        },
    },
    globalOptions: ['spacing', 'showInToc'],
    propsFieldMapping: {
        paragraphs: 'field_content',
    },
});

const b_aU_JDJgSZxGLrK_DQ0JqUwSqB88l8tyBHY6PD9J2cog = ({
    bundle: 'carousel',
    editor: {
        editTitle: (el) => el.querySelector('h2')?.textContent,
    },
    propsFieldMapping: {
        slides: 'field_slides',
    },
});

const b_9TkEiX9C6mC3m5jXpf0T8DbdfPESISlBP2WWk7YcaQM = ({
    bundle: 'search',
    editor: {
        editTitle: (el) => el.querySelector('a')?.innerText,
    },
    globalOptions: ['spacing'],
    propsFieldMapping: {
        header: 'field_header',
    },
});

const b_0H_fxwHQZ3_OLvgq9Xjf6__Ku7nIik2JKRZHH9cFPyk = ({
    bundle: 'image',
    globalOptions: ['spacing', 'imageFormat'],
    editor: {
        editTitle: (el) => {
            const img = el.querySelector('img');
            return img?.alt || img?.title;
        },
        getDraggableElement: (el) => el.querySelector('figure'),
        determineVisibleOptions: (ctx) => {
            if (!ctx.parentType) {
                return ['imageFormat', 'spacing'];
            }
            return ['spacing'];
        },
    },
});

const b__P4WtvCijR54FDCekoZjWYZDU8_uCeA8JQsvFXqxJZ8 = ({
    bundle: 'icon_text_item',
});

const blocks = [
  b_ZD8xe0tDDHb6WP9zG09nDC_r4pdum22GLDmvdfRSc8Y,
  b_z_PD1d7ayF6D7T7L6jozzRtRjSnUKNgO68hY8spvjkY,
  b_YTo_Bh_BHKb8cDCaTnlwUrxSl_UN1TSqX71yK4_5ENk,
  b_xnlIk4Vz0LPjxyXHLu4BcqJSupR_kxyxi8YBrepvpLY,
  b_W69iu88z8RJtGf7iQwLzzEk_jf_97USLPm9ncbU_wFM,
  b_w2jcqcaAlQb_v0OXP3TSWg8_fVRDbSzlDlOcUvL_YIo,
  b_SXVQBz7vbenfDltbhVZKmBaMSNLmgswdA4XXLI5E7UI,
  b_SirCWvX_KaO4m0tSI015B821qfAXhlJaUkOwWX2dqA4,
  b_rZrzUDep3sWJ0Fl9scOVmIOi18oquO7ieJxefD1cflU,
  b_Rnax2e3Lz5SEMemyKl3YlSKNZVEBzCoCHhxEh_X5764,
  b_O6UlFcc3wchuJgPEPOu_dh_UHgzVN94ftwTjQnP1LTM,
  b_NqYDVS6361AcEiJv9sojhqcvqaXzaOHZg82tP3Rg88Q,
  b_fxcUnyIjUiIWx1rgtX0dLiNM22aEC33fVRHHLdqiWXE,
  b_EVC1oo9qUqE74QMcI_ukbajtArb6zExmMcpVexWg0nc,
  b_eh8tCsK7wnmnQy5zHUBJxx_anqZvWJqfOx4Y5p_WPyM,
  b_d5SfFyIgCVs5a6nzYu6vWLBHfuYC7j0_XKqItaVSsIU,
  b_ch06ugUeskqgpetl2fP0tti_H8DvzqAXNBWGRc5aj_U,
  b_cDj4TWfjFUrwMFcI_1KHarrXDMTqdsYf0rg5O_AUVVw,
  b_BwK9rV92vfuPZdhNtUxjMOlPQ1sq0Wlx5d5DPsXUalY,
  b_bUm918TQ8HQXeKMB15CFG0WaTR2QLL9FNdg3AzSu2ss,
  b_AYZjamP3sEPcyFtMO9NMBzVvwxoCSduwY8K9sDLZx90,
  b_aU_JDJgSZxGLrK_DQ0JqUwSqB88l8tyBHY6PD9J2cog,
  b_9TkEiX9C6mC3m5jXpf0T8DbdfPESISlBP2WWk7YcaQM,
  b_0H_fxwHQZ3_OLvgq9Xjf6__Ku7nIik2JKRZHH9cFPyk,
  b__P4WtvCijR54FDCekoZjWYZDU8_uCeA8JQsvFXqxJZ8
]

const fragments = [
  f_O5zAEbylVEdnF53mAmkBE3s7hKZpLJNccIpVfycsVjU
]


const icons = {
  'accordeon': "<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 24 24\"><path d=\"M7.41 8.58 12 13.17l4.59-4.59L18 10l-6 6-6-6 1.41-1.42Z\"/></svg>\n",
  'blokkli_fragment': "<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 24 24\"><title>newspaper</title><path d=\"M20,11H4V8H20M20,15H13V13H20M20,19H13V17H20M11,19H4V13H11M20.33,4.67L18.67,3L17,4.67L15.33,3L13.67,4.67L12,3L10.33,4.67L8.67,3L7,4.67L5.33,3L3.67,4.67L2,3V19A2,2 0 0,0 4,21H20A2,2 0 0,0 22,19V3L20.33,4.67Z\" /></svg>\n",
  'button': "<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 24 24\"><title>button-cursor</title><path d=\"M18.1 15.3C18 15.4 17.8 15.5 17.7 15.6L15.3 16L17 19.6C17.2 20 17 20.4 16.6 20.6L13.8 21.9C13.7 22 13.6 22 13.5 22C13.2 22 12.9 21.8 12.8 21.6L11.2 18L9.3 19.5C9.2 19.6 9 19.7 8.8 19.7C8.4 19.7 8 19.4 8 18.9V7.5C8 7 8.3 6.7 8.8 6.7C9 6.7 9.2 6.8 9.3 6.9L18 14.3C18.3 14.5 18.4 15 18.1 15.3M6 12H4V4H20V12H18.4L20.6 13.9C21.4 13.6 21.9 12.9 21.9 12V4C21.9 2.9 21 2 19.9 2H4C2.9 2 2 2.9 2 4V12C2 13.1 2.9 14 4 14H6V12Z\" /></svg>\n",
  'carousel': "<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 24 24\"><title>view-carousel-outline</title><path d=\"M2 6H6V17H2V6M7 19H17V4H7V19M9 6H15V17H9V6M18 6H22V17H18V6Z\" /></svg>\n",
  'contact': "<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 24 24\"><title>text-long</title><path d=\"M4,5H20V7H4V5M4,9H20V11H4V9M4,13H20V15H4V13M4,17H14V19H4V17Z\" /></svg>\n",
  'gallery': "<svg width=\"26\" height=\"26\" viewBox=\"0 0 26 26\" xmlns=\"http://www.w3.org/2000/svg\">\n    <path d=\"M0 23V9C0 7.34315 1.34315 6 3 6H4V8H3C2.44772 8 2 8.44772 2 9V23C2 23.5523 2.44772 24 3 24H17C17.5523 24 18 23.5523 18 23V22H20V23C20 24.6569 18.6569 26 17 26H3C1.34315 26 0 24.6569 0 23Z\" />\n    <path d=\"M3 20V6C3 4.34315 4.34315 3 6 3H7V5H6C5.44772 5 5 5.44772 5 6V20C5 20.5523 5.44772 21 6 21H20C20.5523 21 21 20.5523 21 20V19H23V20C23 21.6569 21.6569 23 20 23H6C4.34315 23 3 21.6569 3 20Z\" />\n    <path d=\"M24 3C24 2.44772 23.5523 2 23 2H9C8.44772 2 8 2.44772 8 3V17C8 17.5523 8.44772 18 9 18H23C23.5523 18 24 17.5523 24 17V3ZM26 17C26 18.6569 24.6569 20 23 20H9C7.34315 20 6 18.6569 6 17V3C6 1.34315 7.34315 0 9 0H23C24.6569 0 26 1.34315 26 3V17Z\" />\n    <path d=\"M14 7C14 6.44772 13.5523 6 13 6C12.4477 6 12 6.44772 12 7C12 7.55228 12.4477 8 13 8C13.5523 8 14 7.55228 14 7ZM16 7C16 8.65685 14.6569 10 13 10C11.3431 10 10 8.65685 10 7C10 5.34315 11.3431 4 13 4C14.6569 4 16 5.34315 16 7Z\" />\n    <path d=\"M20.5 8.32843C21.2954 8.32843 22.0585 8.64405 22.6211 9.20636V9.20733L25.707 12.2933L25.7754 12.3685C26.0961 12.7612 26.0733 13.3411 25.707 13.7073C25.341 14.0733 24.7619 14.0959 24.3691 13.7757L24.293 13.7073L21.207 10.6214C21.0195 10.4339 20.7652 10.3284 20.5 10.3284C20.2348 10.3284 19.9805 10.4339 19.793 10.6214L10.707 19.7073C10.3165 20.0977 9.68345 20.0977 9.29297 19.7073C8.90249 19.3169 8.9026 18.6838 9.29297 18.2933L18.3789 9.20733V9.20636C18.9415 8.64405 19.7046 8.32843 20.5 8.32843Z\" />\n</svg>\n",
  'icon_text_item': "<?xml version=\"1.0\" encoding=\"UTF-8\"?><svg id=\"uuid-633763d1-014d-4e50-8806-a560206ea69a\" xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 24 24\"><rect x=\"1.44\" y=\"7.04\" width=\"4.22\" height=\"4.22\" rx=\".25\" ry=\".25\" style=\"stroke-width:0px;\"/><rect x=\"6.62\" y=\"7.04\" width=\"15.94\" height=\"1.67\" rx=\".2\" ry=\".2\" style=\"stroke-width:0px;\"/><rect x=\"6.62\" y=\"9.79\" width=\"15.94\" height=\"1.67\" rx=\".2\" ry=\".2\" style=\"stroke-width:0px;\"/><rect x=\"6.62\" y=\"12.54\" width=\"15.94\" height=\"1.67\" rx=\".2\" ry=\".2\" style=\"stroke-width:0px;\"/><rect x=\"6.62\" y=\"15.29\" width=\"10.99\" height=\"1.67\" rx=\".2\" ry=\".2\" style=\"stroke-width:0px;\"/></svg>",
  'icon_text_list': "<?xml version=\"1.0\" encoding=\"UTF-8\"?><svg id=\"uuid-42ea6f3c-630f-4682-8d5c-ff8bd9d1a6d4\" xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 24 24\"><rect x=\"2.58\" y=\"1.68\" width=\"3.43\" height=\"3.43\" rx=\".25\" ry=\".25\" style=\"stroke-width:0px;\"/><rect x=\"6.82\" y=\"1.68\" width=\"14.6\" height=\".9\" rx=\".2\" ry=\".2\" style=\"stroke-width:0px;\"/><rect x=\"6.82\" y=\"3.17\" width=\"14.6\" height=\".9\" rx=\".2\" ry=\".2\" style=\"stroke-width:0px;\"/><rect x=\"6.82\" y=\"4.66\" width=\"14.6\" height=\".9\" rx=\".2\" ry=\".2\" style=\"stroke-width:0px;\"/><rect x=\"6.82\" y=\"6.15\" width=\"10.07\" height=\".9\" rx=\".2\" ry=\".2\" style=\"stroke-width:0px;\"/><rect x=\"2.58\" y=\"9.32\" width=\"3.43\" height=\"3.43\" rx=\".25\" ry=\".25\" style=\"stroke-width:0px;\"/><rect x=\"6.82\" y=\"9.32\" width=\"14.6\" height=\".9\" rx=\".2\" ry=\".2\" style=\"stroke-width:0px;\"/><rect x=\"6.82\" y=\"10.8\" width=\"14.6\" height=\".9\" rx=\".2\" ry=\".2\" style=\"stroke-width:0px;\"/><rect x=\"6.82\" y=\"12.29\" width=\"14.6\" height=\".9\" rx=\".2\" ry=\".2\" style=\"stroke-width:0px;\"/><rect x=\"6.82\" y=\"13.78\" width=\"10.07\" height=\".9\" rx=\".2\" ry=\".2\" style=\"stroke-width:0px;\"/><rect x=\"2.58\" y=\"16.95\" width=\"3.43\" height=\"3.43\" rx=\".25\" ry=\".25\" style=\"stroke-width:0px;\"/><rect x=\"6.82\" y=\"16.95\" width=\"14.6\" height=\".9\" rx=\".2\" ry=\".2\" style=\"stroke-width:0px;\"/><rect x=\"6.82\" y=\"18.44\" width=\"14.6\" height=\".9\" rx=\".2\" ry=\".2\" style=\"stroke-width:0px;\"/><rect x=\"6.82\" y=\"19.93\" width=\"14.6\" height=\".9\" rx=\".2\" ry=\".2\" style=\"stroke-width:0px;\"/><rect x=\"6.82\" y=\"21.42\" width=\"10.07\" height=\".9\" rx=\".2\" ry=\".2\" style=\"stroke-width:0px;\"/></svg>",
  'iframe': "<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 24 24\"><title>application</title><path d=\"M21 2H3C1.9 2 1 2.9 1 4V20C1 21.1 1.9 22 3 22H21C22.1 22 23 21.1 23 20V4C23 2.9 22.1 2 21 2M21 7H3V4H21V7Z\" /></svg>\n",
  'iframe_jobs': "<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 24 24\"><title>application</title><path d=\"M21 2H3C1.9 2 1 2.9 1 4V20C1 21.1 1.9 22 3 22H21C22.1 22 23 21.1 23 20V4C23 2.9 22.1 2 21 2M21 7H3V4H21V7Z\" /></svg>\n",
  'image': "<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 24 24\"><title>image</title><path d=\"M8.5,13.5L11,16.5L14.5,12L19,18H5M21,19V5C21,3.89 20.1,3 19,3H5A2,2 0 0,0 3,5V19A2,2 0 0,0 5,21H19A2,2 0 0,0 21,19Z\" /></svg>\n",
  'info_box': "<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 24 24\"><title>text-long</title><path d=\"M4,5H20V7H4V5M4,9H20V11H4V9M4,13H20V15H4V13M4,17H14V19H4V17Z\" /></svg>\n",
  'link': "<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 24 24\"><title>link-box</title><path d=\"M19,3H5A2,2 0 0,0 3,5V19A2,2 0 0,0 5,21H19A2,2 0 0,0 21,19V5A2,2 0 0,0 19,3M11,16H10C8.39,16 6,14.94 6,12C6,9.07 8.39,8 10,8H11V10H10C9.54,10 8,10.17 8,12C8,13.9 9.67,14 10,14H11V16M15,11V13H9V11H15M14,16H13V14H14C14.46,14 16,13.83 16,12C16,10.1 14.33,10 14,10H13V8H14C15.61,8 18,9.07 18,12C18,14.94 15.61,16 14,16Z\" /></svg>\n",
  'link_list': "<?xml version=\"1.0\" encoding=\"UTF-8\"?><svg id=\"uuid-42ea6f3c-630f-4682-8d5c-ff8bd9d1a6d4\" xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 24 24\"><rect x=\"2.58\" y=\"1.68\" width=\"3.43\" height=\"3.43\" rx=\".25\" ry=\".25\" style=\"stroke-width:0px;\"/><rect x=\"6.82\" y=\"1.68\" width=\"14.6\" height=\".9\" rx=\".2\" ry=\".2\" style=\"stroke-width:0px;\"/><rect x=\"6.82\" y=\"3.17\" width=\"14.6\" height=\".9\" rx=\".2\" ry=\".2\" style=\"stroke-width:0px;\"/><rect x=\"6.82\" y=\"4.66\" width=\"14.6\" height=\".9\" rx=\".2\" ry=\".2\" style=\"stroke-width:0px;\"/><rect x=\"6.82\" y=\"6.15\" width=\"10.07\" height=\".9\" rx=\".2\" ry=\".2\" style=\"stroke-width:0px;\"/><rect x=\"2.58\" y=\"9.32\" width=\"3.43\" height=\"3.43\" rx=\".25\" ry=\".25\" style=\"stroke-width:0px;\"/><rect x=\"6.82\" y=\"9.32\" width=\"14.6\" height=\".9\" rx=\".2\" ry=\".2\" style=\"stroke-width:0px;\"/><rect x=\"6.82\" y=\"10.8\" width=\"14.6\" height=\".9\" rx=\".2\" ry=\".2\" style=\"stroke-width:0px;\"/><rect x=\"6.82\" y=\"12.29\" width=\"14.6\" height=\".9\" rx=\".2\" ry=\".2\" style=\"stroke-width:0px;\"/><rect x=\"6.82\" y=\"13.78\" width=\"10.07\" height=\".9\" rx=\".2\" ry=\".2\" style=\"stroke-width:0px;\"/><rect x=\"2.58\" y=\"16.95\" width=\"3.43\" height=\"3.43\" rx=\".25\" ry=\".25\" style=\"stroke-width:0px;\"/><rect x=\"6.82\" y=\"16.95\" width=\"14.6\" height=\".9\" rx=\".2\" ry=\".2\" style=\"stroke-width:0px;\"/><rect x=\"6.82\" y=\"18.44\" width=\"14.6\" height=\".9\" rx=\".2\" ry=\".2\" style=\"stroke-width:0px;\"/><rect x=\"6.82\" y=\"19.93\" width=\"14.6\" height=\".9\" rx=\".2\" ry=\".2\" style=\"stroke-width:0px;\"/><rect x=\"6.82\" y=\"21.42\" width=\"10.07\" height=\".9\" rx=\".2\" ry=\".2\" style=\"stroke-width:0px;\"/></svg>",
  'newsletter': "<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 24 24\"><title>newsletter</title>\n    <path d=\"M7.2,8.2H2.3c-.2,0-.3.1-.3.3s.1.3.3.3h4.8c.2,0,.3-.1.3-.3s-.1-.3-.3-.3Z\"/>\n    <path d=\"M6.9,10.3h-2.8c-.2,0-.3.1-.3.3s.1.3.3.3h2.8c.2,0,.3-.1.3-.3s-.1-.3-.3-.3Z\"/>\n    <path d=\"M6.7,12.4H2.3c-.2,0-.3.1-.3.3s.1.3.3.3h4.3c.2,0,.3-.1.3-.3s-.1-.3-.3-.3Z\"/>\n    <path d=\"M6.4,14.6h-1.5c-.2,0-.3.1-.3.3s.1.3.3.3h1.5c.2,0,.3-.1.3-.3s-.1-.3-.3-.3Z\"/>\n    <path d=\"M20.5,8h-11l4.9,5.1,6.1-5.1Z\"/>\n    <path d=\"M14.6,13.8c0,0-.1,0-.2,0s-.2,0-.2-.1l-1.2-1.3-4.3,3.5h11l-3.4-3.6-1.6,1.3h0Z\"/>\n    <path d=\"M20.1,15.6l.9-7.1-4.3,3.6,3.5,3.6Z\"/>\n    <path d=\"M8.1,15.5l4.3-3.6-3.5-3.6-.9,7.1Z\"/>\n</svg>",
  'quote': "<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 24 24\"><title>format-quote-close</title><path d=\"M14,17H17L19,13V7H13V13H16M6,17H9L11,13V7H5V13H8L6,17Z\" /></svg>\n",
  'search': "<svg viewBox=\"0 0 20 20\" fill=\"none\" xmlns=\"http://www.w3.org/2000/svg\">\n    <path d=\"M14.1667 14.1666L17.5001 17.5\" stroke=\"currentColor\" stroke-width=\"1.5\" stroke-linecap=\"round\" stroke-linejoin=\"round\"/>\n    <path d=\"M2.5 9.16667C2.5 12.8486 5.48477 15.8333 9.16667 15.8333C11.0108 15.8333 12.6801 15.0846 13.887 13.8744C15.0897 12.6685 15.8333 11.0044 15.8333 9.16667C15.8333 5.48477 12.8486 2.5 9.16667 2.5C5.48477 2.5 2.5 5.48477 2.5 9.16667Z\" stroke=\"currentColor\" stroke-width=\"1.5\" stroke-linecap=\"round\" stroke-linejoin=\"round\"/>\n</svg>\n",
  'teaser': "<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 24 24\"><title>text-box</title><path d=\"M14,17H7V15H14M17,13H7V11H17M17,9H7V7H17M19,3H5C3.89,3 3,3.89 3,5V19A2,2 0 0,0 5,21H19A2,2 0 0,0 21,19V5C21,3.89 20.1,3 19,3Z\" /></svg>\n",
  'teaser_list': "<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 24 24\"><title>view-grid</title><path d=\"M3,11H11V3H3M3,21H11V13H3M13,21H21V13H13M13,3V11H21V3\" /></svg>\n",
  'text': "<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 24 24\"><title>text-long</title><path d=\"M4,5H20V7H4V5M4,9H20V11H4V9M4,13H20V15H4V13M4,17H14V19H4V17Z\" /></svg>\n",
  'text_image': "<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 24 24\"><title>image-text</title><path d=\"M22 13H14V11H22V13M22 7H14V9H22V7M14 17H22V15H14V17M12 9V15C12 16.1 11.1 17 10 17H4C2.9 17 2 16.1 2 15V9C2 7.9 2.9 7 4 7H10C11.1 7 12 7.9 12 9M10.5 15L8.3 12L6.5 14.3L5.3 12.8L3.5 15H10.5Z\" /></svg>\n",
  'title': "<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 24 24\"><title>format-header-2</title><path d=\"M3,4H5V10H9V4H11V18H9V12H5V18H3V4M21,18H15A2,2 0 0,1 13,16C13,15.47 13.2,15 13.54,14.64L18.41,9.41C18.78,9.05 19,8.55 19,8A2,2 0 0,0 17,6A2,2 0 0,0 15,8H13A4,4 0 0,1 17,4A4,4 0 0,1 21,8C21,9.1 20.55,10.1 19.83,10.83L15,16H21V18Z\" /></svg>\n",
  'video': "<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 24 24\"><title>youtube</title><path d=\"M10,15L15.19,12L10,9V15M21.56,7.17C21.69,7.64 21.78,8.27 21.84,9.07C21.91,9.87 21.94,10.56 21.94,11.16L22,12C22,14.19 21.84,15.8 21.56,16.83C21.31,17.73 20.73,18.31 19.83,18.56C19.36,18.69 18.5,18.78 17.18,18.84C15.88,18.91 14.69,18.94 13.59,18.94L12,19C7.81,19 5.2,18.84 4.17,18.56C3.27,18.31 2.69,17.73 2.44,16.83C2.31,16.36 2.22,15.73 2.16,14.93C2.09,14.13 2.06,13.44 2.06,12.84L2,12C2,9.81 2.16,8.2 2.44,7.17C2.69,6.27 3.27,5.69 4.17,5.44C4.64,5.31 5.5,5.22 6.82,5.16C8.12,5.09 9.31,5.06 10.41,5.06L12,5C16.19,5 18.8,5.16 19.83,5.44C20.73,5.69 21.31,6.27 21.56,7.17Z\" /></svg>\n",
  'webform': "<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 24 24\">\n    <title>form-select</title>\n    <path d=\"M15 5H18L16.5 7L15 5M5 2H19C20.11 2 21 2.9 21 4V20C21 21.11 20.11 22 19 22H5C3.9 22 3 21.11 3 20V4C3 2.9 3.9 2 5 2M5 4V8H19V4H5M5 20H19V10H5V20M7 12H17V14H7V12M7 16H17V18H7V16Z\"/>\n</svg>\n"
}



const globalOptions = {"bkVisibleLanguages":{"type":"checkboxes","label":"Visible languages","options":{},"default":[]},"bkHiddenGlobally":{"type":"checkbox","label":"Hide globally","default":false},"showInToc":{"type":"checkbox","label":"Link in der Navigation anzeigen","default":false},"teaserStyle":{"type":"radios","label":"Display","default":"grid","options":{"grid":"Grid","staggered_grid":"Staggered Grid"}},"mobileStyle":{"type":"radios","label":"Mobile display","default":"stapel","options":{"stack":"Stack","slider":"Slider"}},"spacing":{"type":"radios","label":"Spacing","default":"small","displayAs":"icons","options":{"none":{"label":"no spacing","icon":"icon-blokkli-option-no-spacing"},"small":{"label":"small spacing","icon":"icon-blokkli-option-small-spacing"},"large":{"label":"large spacing","icon":"icon-blokkli-option-large-spacing"}}},"imageFormat":{"type":"radios","label":"Image Format","default":"full","displayAs":"icons","options":{"full":{"label":"extra large","icon":"icon-blokkli-option-xlarge"},"big":{"label":"large","icon":"icon-blokkli-option-large"},"text":{"label":"medium","icon":"icon-blokkli-option-medium"},"small":{"label":"small","icon":"icon-blokkli-option-small"}}}}

const renderKey = "ixN6UO-otuQyLNdJivt9WRVrW9wwN8C9L7aVT4LVgQU"

const definitions = {
  blocks,
  fragments,
  icons,
  globalOptions,
  renderKey
}

export default definitions